import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-remove",
  "use": "app-icon-simple-remove-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"app-icon-simple-remove\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M8.7.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm3.5 6a.5.5 0 110 1h-7a.5.5 0 010-1h7z\" fill=\"#2673E5\" fill-rule=\"nonzero\" /><path d=\"M.7 0h16v16H.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol